<template>
  <span class="invown-tooltip" v-if="tooltipData">
    <span :id="triggerId" tabindex="0" class="invown-tooltip__trigger">
      <b-icon-info-circle class="invown-tooltip__icon" />
    </span>
    <b-popover
      :target="triggerId"
      :placement="placement"
      triggers="hover focus"
      container="body"
      :delay="{ show: 300, hide: 100 }"
      custom-class="invown-tooltip__popover"
    >
      <template #title>{{ tooltipData.title }}</template>
      {{ tooltipData.content }}
    </b-popover>
  </span>
</template>

<script>
import tooltips from "@/data/tooltips.json";

export default {
  name: "InvownTooltip",
  props: {
    tooltipId: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: "top",
    },
  },
  computed: {
    tooltipData() {
      return tooltips[this.tooltipId] || null;
    },
    triggerId() {
      return "invown-tip-" + this.tooltipId.replace(/\./g, "-");
    },
  },
};
</script>

<style scoped>
.invown-tooltip {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  vertical-align: middle;
}

.invown-tooltip__trigger {
  cursor: help;
  outline: none;
  display: inline-flex;
  align-items: center;
}

.invown-tooltip__icon {
  color: #6c757d;
  font-size: 0.875rem;
  transition: color 0.15s;
}

.invown-tooltip__trigger:hover .invown-tooltip__icon,
.invown-tooltip__trigger:focus .invown-tooltip__icon {
  color: #495057;
}
</style>

<style>
.invown-tooltip__popover {
  max-width: 320px;
}
.invown-tooltip__popover .popover-header {
  font-weight: 600;
  font-size: 0.875rem;
}
.invown-tooltip__popover .popover-body {
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #495057;
}
</style>
